import React, { Component } from "react";
import { RouteChildrenProps } from "react-router-dom";
import regbanner from "../../../assets/icons/verificationInProgress.png";
import Button from "../../UI/Button/Button";

import "./DocsVerificationInProgress.scss";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import GlobalStore from "../../store/globalStore";

class DocsVerificationInProgress extends Component<RouteChildrenProps> {
  render() {
    const showMessage = () => {
      let show: boolean = false,
        userId = "0",
        accountcategory = "0";
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      let tokenObj: string = decryptJwtToken(
        !!GlobalStore?.token && GlobalStore?.token !== ""
          ? GlobalStore?.token
          : clientPartialDetails_ao.token
      );

      if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
        let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
        userId = tokenMainObj?.UserId?.toString();
        accountcategory = tokenMainObj?.AccountCategory.toString();
      }
      if (userId != "0" && accountcategory == "2") {
        show = true;
      }
      return show;
    };
    return (
      <div className="docs-pending-root">
        <img src={regbanner} className="verified-img" />
        <div>
          <h2 className="status-heading">Document Verification in Process</h2>
          <span className="status-subHead">
            {showMessage() ? (
              <>
                The documents have been successfully received for quality check.
                This process may take up to 45 minutes.
                You can track the customer journey on One Platform in Order Book.
              </>
            ) : (
              <>
                {" "}
                Your documents are getting verified by our <br />
                agents.This process usually take 1-2 <br /> business days
              </>
            )}
          </span>
          {!showMessage() &&
            <div className="notes">
              We will notify you of the update via{" "}
              <span className="email-text">WhatsApp/Email</span>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default DocsVerificationInProgress;
